"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EarleyParser = void 0;
var EarleyItem_1 = require("./EarleyItem");
var Token_1 = require("./Token");
/**
  The Earley parser is like the proverbial tortoise. Its simplicity lets slowly
  but surely it chug through any grammar you throw its way.

  @constructor
 */
var EarleyParser = /** @class */ (function () {
    function EarleyParser(ruleSet, dbg) {
        this.dbg = dbg;
        this.errors = [];
        this.debug = false; //true;
        // Map from rule name to NFA.
        this.tokenizer = ruleSet.createTokenizer(dbg);
        this.EPSILON = ruleSet.EPSILON;
        ruleSet.computeFirst();
        this.rules = ruleSet.rules;
        this.first = ruleSet.first;
        //this.debug = true;
    }
    EarleyParser.prototype.getNonTerminal = function (name) {
        return this.rules[name];
    };
    EarleyParser.prototype.getRegexFromTerminal = function (terminal) {
        return terminal.substr(1, terminal.length - 2);
    };
    EarleyParser.prototype.isTerminal = function (symbol) {
        return symbol !== undefined && symbol[0] == "'";
    };
    EarleyParser.prototype.isNonTerminal = function (symbol) {
        return symbol !== undefined && symbol[0] != "'";
    };
    EarleyParser.prototype.parse = function (text) {
        var dbg = this.dbg;
        var states = [[new EarleyItem_1.EarleyItem(this.rules['_start'][0], 0, 0)]];
        var line = 0;
        var position = 0;
        var j;
        this.tokenizer.setText(text);
        this.errors = [];
        for (var i = 0;; i++) {
            var token = this.tokenizer.nextToken(line, position);
            if (token === null) {
                this.errors.push("Bad token at " + (line + 1) + ":" + (position + 1) + "\n");
                dbg.print('Bad token!\n');
                return null;
            }
            else if (this.debug) {
                dbg.print("'Got token " + token + " at " + token.location.toString() + "\n");
            }
            this.location = token.location;
            states.push([]);
            var processedTo = 0;
            while (processedTo < states[i].length) {
                // remain calm
                this.predict(states[i], processedTo, i, token);
                this.complete(states, i, processedTo, i);
                processedTo++;
            }
            this.scan(states, i, token);
            if (states[i].length === 0) {
                this.errors.push("Syntax error at " + this.location + ": " + token);
                for (j = 0; j < states[i - 1].length; j++) {
                    this.errors.push("    " + states[i - 1][j] + "\n");
                }
                break;
            }
            if (this.debug) {
                this.printState(states, i);
            }
            line = token.location.line;
            position = token.location.position + token.text.length;
            if (token.id === this.tokenizer.EOF_TOKEN) {
                //dbg.printf("Reached end of input.\n");
                i++;
                break;
            }
        }
        if (this.debug) {
            this.printState(states, i);
        }
        if (states[i].length) {
            return this.evaluate(states[i][0]);
        }
        this.errors.push("Syntax error at " + this.location);
        for (j = 0; j < states[i - 1].length; j++) {
            this.errors.push("    " + states[i - 1][j] + "\n");
        }
        return null;
    };
    EarleyParser.prototype.predict = function (items, index, base, token) {
        var item = items[index];
        if (this.isNonTerminal(item.rule.symbols[item.pos])) {
            var nonTerminal = this.getNonTerminal(item.rule.symbols[item.pos]);
            for (var i = 0; i < nonTerminal.length; i++) {
                var rule = nonTerminal[i];
                if (rule.symbols.length === 0 ||
                    rule.symbols[0][0] === "'" ||
                    this.first[rule.symbols[0]][token.id] ||
                    this.first[rule.symbols[0]][this.EPSILON]) {
                    this.addToState(items, rule, 0, base, undefined, undefined);
                }
            }
        }
    };
    EarleyParser.prototype.complete = function (states, i, index, _base) {
        var item = states[i][index];
        if (item.pos == item.rule.symbols.length) {
            var baseItems = states[item.base];
            for (var j = 0; j < baseItems.length; j++) {
                if (baseItems[j].rule.symbols[baseItems[j].pos] == item.rule.name) {
                    this.addToState(states[i], baseItems[j].rule, baseItems[j].pos + 1, baseItems[j].base, item, baseItems[j]);
                }
            }
        }
    };
    EarleyParser.prototype.scan = function (states, i, token) {
        var items = states[i];
        for (var j = 0; j < items.length; j++) {
            if (items[j].rule.symbols[items[j].pos] == token.id) {
                states[i + 1].push(new EarleyItem_1.EarleyItem(items[j].rule, items[j].pos + 1, items[j].base, token, items[j], this.location));
            }
        }
    };
    EarleyParser.prototype.addToState = function (items, rule, pos, base, token, prev) {
        for (var i = 0; i < items.length; i++) {
            if (items[i].rule === rule &&
                items[i].pos === pos &&
                items[i].base === base) {
                return;
            }
        }
        items.push(new EarleyItem_1.EarleyItem(rule, pos, base, token, prev, this.location));
    };
    EarleyParser.prototype.printState = function (states, index) {
        var dbg = this.dbg;
        if (!this.debug) {
            return;
        }
        var items = states[index];
        dbg.print("State [" + index + "]\n");
        for (var i = 0; i < items.length; i++) {
            dbg.print(items[i] + "\n");
        }
        dbg.print('\n');
    };
    // ----------------------------------------------------------------------
    // Given an earley item, reconstruct the dervation and invoke any associated
    // actions.
    // ----------------------------------------------------------------------
    EarleyParser.prototype.evaluate = function (item_in) {
        if (!item_in) {
            return null;
        }
        var args = [];
        var item = item_in;
        var location = item_in.location;
        while (item) {
            if (item.token instanceof Token_1.Token) {
                args.unshift(item.token.text);
            }
            else if (item.token) {
                args.unshift(this.evaluate(item.token));
            }
            location = item.location;
            item = item.prev;
        }
        // let result;
        // if (item_in.rule.action) {
        //   result = item_in.rule.action(args, location!);
        // } else {
        //   result = args[0];
        // }
        // return result;
        return item_in.rule.action ? item_in.rule.action(args, location) : args[0];
    };
    return EarleyParser;
}());
exports.EarleyParser = EarleyParser;
//# sourceMappingURL=EarleyParser.js.map